import { toast } from "react-toastify";
import apiClient from "../../../constants/apiClient";
import { ROOT_URL } from "../../../constants/urls";
import { isLabelSide } from "./constants";

/** Strip label images before API: backend does not need them (OCR is frontend-only), avoids heavy base64 on slow networks */
function sanitizePayloadForApi(payload) {
  if (!payload) return payload;
  const sanitized = { ...payload };
  if (payload.images) {
    sanitized.images = { ...payload.images };
    for (const key of Object.keys(sanitized.images)) {
      if (isLabelSide(key)) {
        sanitized.images[key] = { url: 'n/a', base64: false };
      }
    }
  }
  return sanitized;
}

export function postClaim(post, validate = false) {
  return function (dispatch) {
    if (validate) {
      dispatch({ type: "CLAIM_IS_SUBMITTING", payload: true });

      const payload = sanitizePayloadForApi(post);
      apiClient.post(`${ROOT_URL}api/claims`, payload)
        .then(response => {
          const data = response.data;

          if (data.message) {
            toast.info(data.message);
          }
          dispatch({ type: "POST", payload: data });
        })
        .catch((error) => {
          // Handle error if needed
        })
        .finally(() => {
          dispatch({ type: "CLAIM_IS_SUBMITTING", payload: false });
        });

    } else {
      dispatch({ type: "POST", payload: post });
    }
  };
}


export function patchClaim(post) {
  return function (dispatch) {
    dispatch({ type: "PATCH", payload: post });
  };
}

export function patchMeta(name, scanned) {
  return function (dispatch) {
    dispatch({
      type: "PATCH_META",
      payload: { name, scanned }
    });
  };
}

